import { BlogPost } from '../types/blog';

export const blogPosts: BlogPost[] = [
  {
    id: '1',
    title: 'Cómo Detectar Problemas Eléctricos en tu Hogar antes de que sean Graves',
    slug: 'detectar-problemas-electricos-hogar',
    excerpt: 'Aprende a identificar las señales de advertencia de problemas eléctricos en tu casa y evita situaciones peligrosas.',
    content: `Los problemas eléctricos pueden ser peligrosos si no se detectan a tiempo. Aquí te explicamos las señales más comunes y cómo actuar ante ellas:

1. Luces que parpadean o fluctúan
- Causas: Conexiones sueltas, sobrecarga del circuito, problemas en el transformador
- Cuándo preocuparse: Si ocurre frecuentemente o afecta a múltiples luces
- Soluciones: Revisión profesional del cableado y conexiones

2. Enchufes que chispean
- Señales de peligro: Chispas azules o amarillas, marcas de quemadura
- Medidas preventivas: No sobrecargar los enchufes, mantener alejados materiales inflamables
- Cuándo llamar: Inmediatamente si las chispas son frecuentes o hay olor a quemado

3. Diferenciales o magnetotérmicos que saltan con frecuencia
- Razones: Sobrecarga del circuito, cortocircuito, aparatos defectuosos
- Diagnóstico: Identificar qué aparatos causan el problema
- Soluciones: Redistribución de cargas, actualización del cuadro eléctrico

4. Olores a quemado cerca de enchufes
- Identificación: Localizar la fuente exacta del olor
- Acciones inmediatas: Desconectar aparatos y cortar la corriente
- Prevención: Inspección regular de enchufes y conexiones

5. Cables desgastados o dañados
- Inspección visual: Buscar grietas, desgaste o exposición del cableado
- Riesgos: Cortocircuitos, incendios, descargas eléctricas
- Mantenimiento: Reemplazo inmediato de cables dañados

Es fundamental realizar inspecciones regulares y contactar a un electricista profesional ante cualquier señal de alarma. La prevención y el mantenimiento son clave para la seguridad eléctrica en el hogar.`,
    image: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e',
    imageAlt: 'Electricista revisando un cuadro eléctrico con equipo de seguridad',
    date: '2024-03-15',
    author: 'José García',
    category: 'electrical',
    tags: ['seguridad eléctrica', 'mantenimiento eléctrico', 'problemas eléctricos', 'instalación eléctrica']
  },
  {
    id: '2',
    title: 'Guía Completa del Certificado de Instalación Eléctrica (CIE)',
    slug: 'guia-certificado-instalacion-electrica-cie',
    excerpt: 'Todo lo que necesitas saber sobre el Certificado de Instalación Eléctrica (CIE): requisitos, proceso y documentación necesaria.',
    content: `El Certificado de Instalación Eléctrica (CIE) es un documento esencial que garantiza la seguridad de tu instalación eléctrica. Esta guía te ayudará a entender todo lo necesario:

1. ¿Qué es el CIE?
- Documento oficial obligatorio
- Garantía de cumplimiento normativo
- Validez legal de la instalación

2. ¿Cuándo se necesita?
- Nuevas instalaciones
- Modificaciones importantes
- Cambios de potencia
- Compraventa de inmuebles

3. Proceso de obtención
- Inspección técnica inicial
- Verificación de la instalación
- Documentación necesaria
- Trámites administrativos

4. Requisitos técnicos
- Normativa aplicable
- Especificaciones técnicas
- Medidas de seguridad
- Protecciones necesarias

5. Validez y renovación
- Periodo de vigencia
- Inspecciones periódicas
- Proceso de renovación
- Costes aproximados

La obtención del CIE es un proceso que requiere la intervención de profesionales cualificados y el cumplimiento estricto de la normativa vigente.`,
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837',
    imageAlt: 'Documentos oficiales y planos eléctricos sobre una mesa',
    date: '2024-03-14',
    author: 'María Torres',
    category: 'electrical',
    tags: ['certificado CIE', 'normativa eléctrica', 'instalación eléctrica', 'documentación']
  },
  {
    id: '3',
    title: 'Instalación de Puntos de Recarga para Vehículos Eléctricos',
    slug: 'instalacion-puntos-recarga-vehiculos-electricos',
    excerpt: 'Guía definitiva sobre la instalación de puntos de recarga en comunidades y viviendas: normativa, proceso y subvenciones.',
    content: `La instalación de puntos de recarga para vehículos eléctricos es cada vez más demandada. Esta guía te ayudará a entender todos los aspectos importantes:

1. Tipos de puntos de recarga
- Carga lenta (hasta 7,4 kW)
- Carga semi-rápida (hasta 22 kW)
- Carga rápida (50 kW o más)
- Ventajas y desventajas de cada tipo

2. Requisitos técnicos
- Potencia necesaria
- Tipo de instalación
- Protecciones eléctricas
- Conectores disponibles

3. Proceso de instalación
- Estudio previo
- Trámites administrativos
- Instalación física
- Certificación y puesta en marcha

4. Normativa aplicable
- Reglamento electrotécnico
- Normativas específicas
- Requisitos de seguridad
- Certificaciones necesarias

5. Subvenciones disponibles
- Ayudas estatales
- Ayudas autonómicas
- Requisitos para solicitarlas
- Proceso de tramitación

La instalación debe ser realizada por profesionales cualificados para garantizar la seguridad y eficiencia del sistema.`,
    image: 'https://images.unsplash.com/photo-1593941707882-a5bba14938c7',
    imageAlt: 'Cargador conectado a un coche eléctrico',
    date: '2024-03-13',
    author: 'Carlos Ruiz',
    category: 'electrical',
    tags: ['vehículo eléctrico', 'punto recarga', 'instalación eléctrica', 'movilidad sostenible']
  },
  {
    id: '4',
    title: 'Ahorro Energético: Cómo Reducir tu Factura de Luz',
    slug: 'ahorro-energetico-reducir-factura-luz',
    excerpt: 'Consejos prácticos y soluciones efectivas para reducir el consumo eléctrico y ahorrar en tu factura mensual.',
    content: `Reducir el consumo eléctrico no solo beneficia a tu bolsillo, sino también al medio ambiente. Aquí te explicamos cómo lograrlo:

1. Iluminación eficiente
- Cambio a tecnología LED
- Aprovechamiento de luz natural
- Sensores de movimiento
- Temporizadores

2. Electrodomésticos eficientes
- Clasificación energética
- Uso óptimo
- Mantenimiento adecuado
- Renovación de equipos antiguos

3. Climatización inteligente
- Aislamiento térmico
- Termostatos programables
- Uso eficiente
- Mantenimiento preventivo

4. Hábitos de consumo
- Horarios valle
- Desconexión de standby
- Uso consciente
- Monitorización del consumo

5. Mejoras en la instalación
- Revisión del contrato
- Optimización de potencia
- Corrección del factor de potencia
- Mantenimiento preventivo

Implementar estas medidas puede suponer un ahorro significativo en tu factura mensual.`,
    image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e',
    imageAlt: 'Bombilla LED moderna en un entorno doméstico',
    date: '2024-03-12',
    author: 'Ana López',
    category: 'electrical',
    tags: ['ahorro energético', 'eficiencia energética', 'factura luz', 'consumo eléctrico']
  },
  {
    id: '5',
    title: 'Seguridad Eléctrica en Reformas: Lo que Debes Saber',
    slug: 'seguridad-electrica-reformas',
    excerpt: 'Aspectos fundamentales de seguridad eléctrica a considerar durante la reforma de tu vivienda.',
    content: `La seguridad eléctrica es crucial en cualquier reforma. Aquí te explicamos los aspectos más importantes:

1. Normativa vigente
- Reglamento electrotécnico
- Normativas locales
- Certificaciones necesarias
- Documentación requerida

2. Elementos de seguridad
- Protecciones eléctricas
- Tomas de tierra
- Diferenciales
- Magnetotérmicos

3. Instalación segura
- Dimensionamiento correcto
- Materiales homologados
- Conexiones adecuadas
- Canalizaciones

4. Profesionales cualificados
- Electricistas autorizados
- Certificaciones necesarias
- Experiencia demostrable
- Seguros de responsabilidad

5. Mantenimiento posterior
- Revisiones periódicas
- Documentación actualizada
- Modificaciones seguras
- Registro de intervenciones

La seguridad eléctrica no es negociable en una reforma.`,
    image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd',
    imageAlt: 'Electricista trabajando en una reforma con equipo de seguridad',
    date: '2024-03-11',
    author: 'Pedro Sánchez',
    category: 'housing',
    tags: ['reforma', 'seguridad eléctrica', 'normativa', 'instalación eléctrica']
  }
];
// Artículos generados cada día por scripts/blog-diario.mjs (datos en autoPosts.json)
import autoPosts from './autoPosts.json';
for (const p of autoPosts as any[]) {
  blogPosts.push({ id: p.id, slug: p.slug, date: p.date, image: p.image, author: p.author, category: p.category, ...p.i18n.es });
}
